module.exports = __webpack_public_path__ + "static/img/emoji.cda911d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji.png
// module id = wCNe
// module chunks = 9